import { useState } from 'react'
import './CancelRequestModal.css'

interface CancelRequestModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: (reason: string) => void
  requestSubject?: string
  title?: string
  warning?: string
  reasonLabel?: string
  reasonPlaceholder?: string
  confirmLabel?: string
  emptyReasonError?: string
}

export function CancelRequestModal({
  isOpen,
  onClose,
  onConfirm,
  requestSubject,
  title = 'Zrušit žádost',
  warning = 'Opravdu chcete zrušit tuto žádost? Tato akce změní status žádosti na "Zamítnuto vedoucím".',
  reasonLabel = 'Důvod zrušení',
  reasonPlaceholder = 'Zadejte důvod zrušení žádosti (minimálně 10 znaků)',
  confirmLabel = 'Potvrdit zrušení',
  emptyReasonError = 'Prosím zadejte důvod zrušení žádosti',
}: CancelRequestModalProps) {
  const [reason, setReason] = useState('')
  const [error, setError] = useState('')

  if (!isOpen) return null

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    
    if (!reason.trim()) {
      setError(emptyReasonError)
      return
    }

    if (reason.trim().length < 10) {
      setError('Důvod zrušení musí obsahovat alespoň 10 znaků')
      return
    }

    onConfirm(reason.trim())
    setReason('')
    setError('')
  }

  const handleClose = () => {
    setReason('')
    setError('')
    onClose()
  }

  return (
    <div className="cancel-request-modal-overlay" onClick={handleClose}>
      <div className="cancel-request-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="cancel-request-modal-header">
          <h2>{title}</h2>
          <button className="cancel-request-modal-close" onClick={handleClose} title="Zavřít">
            ×
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="cancel-request-modal-body">
            {requestSubject && (
              <p className="cancel-request-subject">
                <strong>Předmět žádosti:</strong> {requestSubject}
              </p>
            )}
            <p className="cancel-request-warning">{warning}</p>
            <div className="cancel-request-form-group">
              <label htmlFor="cancel-reason">
                {reasonLabel} <span className="required">*</span>
              </label>
              <textarea
                id="cancel-reason"
                value={reason}
                onChange={(e) => {
                  setReason(e.target.value)
                  setError('')
                }}
                placeholder={reasonPlaceholder}
                rows={5}
                required
                className={error ? 'error' : ''}
              />
              {error && <div className="cancel-request-error">{error}</div>}
            </div>
          </div>
          <div className="cancel-request-modal-footer">
            <button type="button" className="btn-cancel" onClick={handleClose}>
              Zrušit
            </button>
            <button type="submit" className="btn-confirm-cancel">
              {confirmLabel}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default CancelRequestModal
